import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Banner from "images/png/promotion-banner.jpg";
import PatternImg from "images/png/rated-playlist-background-pattern.png";
import ActivePromotion from "./activePromotion";
import { useNavigate } from "react-router-dom";

const Default = () => {
  const navigate = useNavigate();
  return (
    <>
      <Main>
        <BgHeader src={PatternImg} alt="bg-header" />
        <LeftSide>
          <Typography size="4xl" m_size="xl" weight="bold" mb="3.2">
            Music Promotion
          </Typography>
          <Typography size="6rem" m_size="2.8rem" weight="semibold" mb="1.6">
            Get The Spotlight Your Music Deserves
          </Typography>

          <Typography size="2xl" m_size="m" color={Colors.grey500} mb="3.2">
            From{" "}
            <span style={{ fontWeight: "bold", color: Colors.grey100 }}>
              TV
            </span>{" "}
            and{" "}
            <span style={{ fontWeight: "bold", color: Colors.grey100 }}>
              Radio
            </span>{" "}
            to{" "}
            <span style={{ fontWeight: "bold", color: Colors.grey100 }}>
              Press
            </span>{" "}
            and{" "}
            <span style={{ fontWeight: "bold", color: Colors.grey100 }}>
              Blogs
            </span>{" "}
            , Rated Afrika Promotion connects you to real exposure across Africa
            and beyond. Choose a medium, reach the right audience, and{" "}
            <span style={{ fontWeight: "bold", color: Colors.grey100 }}>
              grow
            </span>{" "}
            your fanbase.
          </Typography>
          <PrimaryButton
            text="Start Promoting"
            fitContent
            sparkle
            inset
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M3.3335 10H16.6668M16.6668 10L11.6668 5M16.6668 10L11.6668 15"
                  stroke="#131313"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
            iconPosition="right"
            onClick={() => {
              navigate("/promotion/promo-type");
            }}
          />
        </LeftSide>
        <RightSide>
          <Image src={Banner} alt="img" />
        </RightSide>
      </Main>
      <ActivePromotion />
    </>
  );
};

export default Default;

const Main = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
  }
`;

const LeftSide = styled.div`
  width: 50%;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const RightSide = styled.div`
  width: 50%;
  display: flex;
  justify-content: end;
  @media only screen and (max-width: 769px) {
    width: 100%;
    justify-content: center;
  }
`;

const BgHeader = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  @media only screen and (max-width: 769px) {
    width: 100rem;
    justify-content: center;
  }
`;

const Image = styled.img`
  width: 54rem;
  z-index: 1;
  @media only screen and (max-width: 769px) {
    width: 40rem;
  }
`;
